import React from "react";
import Axios from 'axios';
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import API from '../Utils/api';
import { Link } from "@material-ui/core";

export class MasterSolicitacoes extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      pedidos: {},
      user: JSON.parse(localStorage.getItem("user")),
      solicitacoes: [],
      groupedSolicitacoes: {}
    };
    this.obterTodasSolicitacoes();
  }

  async obterTodasSolicitacoes() {
    try {
      const response = await API.post("/api/v1/app/obter-comissoes-todos", {});
      const solicitacoes = response.data.reverse();
      this.setState({ solicitacoes }, this.groupSolicitacoesByStatusAndUser);
    } catch (err) {
      console.log(err);
    }
  }

  groupSolicitacoesByStatusAndUser() {
    const groupedSolicitacoes = this.state.solicitacoes.reduce((acc, solicitacao) => {
      const groupKey = `${solicitacao.status}-${solicitacao.usuarioId.nome}`;
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(solicitacao);
      return acc;
    }, {});
    this.setState({ groupedSolicitacoes });
  }

  async updateStatus(solicitacaoId, solicitacaoStatus) {
    try {
      await API.post("/api/v1/app/alterar-status-comissao", { comissaoId: solicitacaoId, status: solicitacaoStatus });
      this.setState(prevState => {
        const updatedSolicitacoes = prevState.solicitacoes.map(solicitacao => 
          solicitacao._id === solicitacaoId ? { ...solicitacao, status: solicitacaoStatus } : solicitacao
        );
        return { solicitacoes: updatedSolicitacoes };
      }, this.groupSolicitacoesByStatusAndUser);
    } catch (err) {
      console.log(err);
    }
  }

  async updateGroupStatus(groupKey, newStatus) {
    try {
      const solicitacoesToUpdate = this.state.groupedSolicitacoes[groupKey];
      const updatePromises = solicitacoesToUpdate.map(solicitacao => 
        API.post("/api/v1/app/alterar-status-comissao", { comissaoId: solicitacao._id, status: newStatus })
      );
      await Promise.all(updatePromises);
      this.setState(prevState => {
        const updatedSolicitacoes = prevState.solicitacoes.map(solicitacao => 
          groupKey === `${solicitacao.status}-${solicitacao.usuarioId.nome}` ? { ...solicitacao, status: newStatus } : solicitacao
        );
        return { solicitacoes: updatedSolicitacoes };
      }, this.groupSolicitacoesByStatusAndUser);
    } catch (err) {
      console.log(err);
    }
  }

  formatDate(data) {
    return moment(data).format('DD-MM-YYYY');
  }

  renderGroupedRows(groupKey, solicitacoes) {
    const [status, nome] = groupKey.split('-');
    const totalValue = solicitacoes.reduce((sum, solicitacao) => sum + solicitacao.valor, 0);
    const dates = solicitacoes.map(solicitacao => moment(solicitacao.data));
    const startDate = moment.min(dates).format('DD-MM-YYYY');
    const endDate = moment.max(dates).format('DD-MM-YYYY');

    return (
      <tr key={groupKey} className="align-items-center">
        <td>{this.formatDate(solicitacoes[0].data)}</td>
        <td>{startDate} / {endDate}</td>
        <td>{nome}</td>
        <td className="w-100 d-flex justify-content-center">{'R$ ' + totalValue}</td>
        <td>{solicitacoes[0].usuarioId.chavepix}</td>
        <td>{status}</td>
        <td className="w-100 d-flex justify-content-center">
          <div className="dropdown">
            <Link to="#" id={`dLabel_${groupKey}`}
              type="button" data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <i className="fas fa-ellipsis-h"></i>
            </Link>
            <div className="dropdown-menu"
              aria-labelledby={`dLabel_${groupKey}`}>
              <Link className="dropdown-item"
                onClick={() => this.updateGroupStatus(groupKey, "Recusado")}
                to="#">Recusar Todos</Link>
              <Link className="dropdown-item"
                onClick={() => this.updateGroupStatus(groupKey, "Pago")}
                to="#">Pagar Todos</Link>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  renderIndividualRow(solicitacao, index) {
    return (
      <tr key={solicitacao._id} className="align-items-center">
        <td className="d-flex align-items-center">{this.formatDate(solicitacao.data)}</td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>{this.formatDate(solicitacao.periodo.dataInicial)}</span>
            <span>{this.formatDate(solicitacao.periodo.dataFinal)}</span>
          </div>
        </td>
        <td><span>{solicitacao.usuarioId.nome}</span></td>
        <td className="w-100 d-flex justify-content-center"><span>{'R$ ' + solicitacao.valor}</span></td>
        <td><span>{solicitacao.usuarioId.chavepix ? solicitacao.usuarioId.chavepix : "- - - - - - - -"}</span></td>
        <td><span className="font-weight-bold">{solicitacao.status}</span></td>
        <td className="w-100 d-flex justify-content-center">
          <div className="dropdown">
            <Link to="#" id={`dLabel_${index}`}
              type="button" data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <i className="fas fa-ellipsis-h"></i>
            </Link>
            <div className="dropdown-menu"
              aria-labelledby={`dLabel_${index}`}>
              <Link className="dropdown-item"
                onClick={() => this.updateStatus(solicitacao._id, "Recusado")}
                to="#">Recusar</Link>
              <Link className="dropdown-item"
                onClick={() => this.updateStatus(solicitacao._id, "Pago")}
                to="#">Pagar</Link>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  render() {
    return (
      <MasterTemplate label="Solicitações de saque">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card strpied-tabled-with-hover">
                  <div className="card-header">
                    <h4 className="card-title">Atenção lembre-se de atualizar o status da solicitação.</h4>
                    <p className="card-category">Solicitações de saque.</p>
                  </div>
                  <div className="card-body table-full-width table-responsive">
                    <table className="table table-hover table-striped">
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Referente ao periodo</th>
                          <th>Solicitante</th>
                          <th className="w-100 d-flex justify-content-center">Total da comissão</th>
                          <th>Chave pix</th>
                          <th>Status</th>
                          <th className="w-100 d-flex justify-content-center">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(this.state.groupedSolicitacoes).map(([groupKey, solicitacoes]) => (
                          this.renderGroupedRows(groupKey, solicitacoes)
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterTemplate>
    );
  }
}

export default MasterSolicitacoes;